// 角色翻譯函數
export const getRoleLabel = (role) => {
  const roleMap = {
    super_admin: '超級管理員',
    company_admin: '公司管理員',
    department_admin: '部門管理員',
    member: '成員',
    admin: '管理員',
    guest: '訪客'
  };
  return roleMap[role] || role;
};

